export interface IQuickMessageItem {
  id: string;
  shortcut: string;
  title?: string;
  message: string;
  backgroundColor?: string;
  color?: string;
  order?: number;
  ats?: any[];
  image?: any[];
  video?: any[];
  pageId?: string;
  /** [§3.D.2] Category chứa item này — FE13 qmsg category filter */
  categoryId?: string;
  /** [FE13] Tin nhắn con */
  childs?: any[];
  /** [FE13] Xin thông tin: 1 = SĐT + địa chỉ, 3 = SĐT, 2 = tắt. */
  requireAddress?: number;
  /** [FE13] Thứ tự gửi: '1' = IMAGE_FIRST, '2' = TEXT_FIRST */
  sendPriority?: string;
  /** [FE13] WA template data */
  templates?: any[];
  /** [FE13] WA form ID */
  formId?: string;
  /** Thời điểm tạo — BE sắp xếp theo order rồi createdTime */
  createdTime?: number;
  /** Tin không có phím tắt, FE tự đánh số "/<vị trí>" như FE13 */
  autoShortcut?: boolean;
}

/** Trạng thái tin nhắn nhanh (BE QuickMessage::STATUS_*) — hội thoại chỉ dùng tin đang bật. */
export const QUICK_MESSAGE_STATUS = {
  ACTIVE: 1,
  INACTIVE: 2,
} as const;

export interface IQuickMessageCategory {
  id: string;
  name: string;
  order: number;
}
